










import Vue from 'vue';
import {Component, Prop, Watch} from 'vue-property-decorator';

@Component
export default class SegmentControls extends Vue {
  @Prop(String) value!: string;
  @Prop(String) manageType!: string;
  @Prop(String) statisticType!: string;

  type = this.value;

  @Watch('type')
  onTypeChanged() {
    this.$emit('update:value', this.type);
    this.$emit('update:manageType', this.type);
    this.$emit('update:statisticType', this.type);
  }

  selectType(value: string) {
    this.type = value;
  }

}
